module.exports = __webpack_public_path__ + "img/NDZ_Goat.977fb53e.svg";